/**
 * Définitions KPI Analytics — langage commerçant (tooltips ⓘ).
 * SOURCE = documentation interne (non affichée).
 */

export const ANALYTICS_KPI_DEFINITIONS = {
  caNetVentes: {
    label: 'CA net ventes',
    definition:
      'Montant des ventes payées sur la période, après déduction des remboursements. Les ventes de cartes cadeaux ne sont pas incluses ici.',
    source: 'ledger paiements commandes (VALIDE/REMBOURSE) hors émission Gift',
  },
  caBrut: {
    label: 'Chiffre d’affaires avant remboursements',
    definition: 'Montant des ventes payées avant déduction des remboursements.',
    source: 'ledger paiements',
  },
  remboursements: {
    label: 'Remboursements',
    definition:
      'Total des remboursements effectués sur les ventes de la période. Ils sont déduits du chiffre d’affaires net.',
    source: 'ledger remboursements',
  },
  commandesPayees: {
    label: 'Commandes payées',
    definition:
      'Nombre de commandes ayant été payées sur la période, y compris celles remboursées ensuite. Les ventes de cartes cadeaux ne sont pas comptées comme des ventes.',
    source: 'commandes VALIDE/REMBOURSE hors Gift',
  },
  panierMoyen: {
    label: 'Panier moyen ventes',
    definition:
      'Chiffre d’affaires net des ventes divisé par le nombre de commandes payées sur la même période.',
    source: 'CA net / volume commandes',
  },
  comptesPlateforme: {
    label: 'Comptes plateforme',
    definition:
      'Nombre total de comptes enregistrés sur Clickorico (tous rôles). Total actuel — indépendant de la période sélectionnée. Ce n’est pas la liste Clients filtrée.',
    source: 'User.count() global, hors filtre période',
  },
  clientsBoutique: {
    label: 'Clients boutique',
    definition:
      'Clients visibles dans le module Clients : comptes actifs hors rôles admin/commerçant, hors comptes gérant boutique et invités caisse.',
    source: 'GET /users filtré + filterClientsOnly',
  },
  visiteursIdentifies: {
    label: 'Visiteurs identifiés',
    definition:
      'Comptes connectés ayant consulté CETTE boutique (page_views.userId). Ce n’est pas forcément un client ayant déjà commandé — un commerçant ou un admin peut apparaître.',
    source: 'page_views avec userId non null (sessions distinctes), sans filtre rôle',
  },
  /** @deprecated alias — préférer visiteursIdentifies */
  clientsConnectes: {
    label: 'Visiteurs identifiés',
    definition:
      'Comptes connectés ayant consulté CETTE boutique (page_views.userId). Ce n’est pas forcément un client ayant déjà commandé — un commerçant ou un admin peut apparaître.',
    source: 'page_views avec userId non null (sessions distinctes), sans filtre rôle',
  },
  visiteursAnonymes: {
    label: 'Visiteurs sans compte',
    definition: 'Visites sur votre boutique sans connexion à un compte.',
    source: 'page_views sessionId sans userId',
  },
  commercantsSnapshot: {
    label: 'Commerçants (total)',
    definition:
      'Nombre total de boutiques enregistrées. Total actuel — indépendant de la période sélectionnée.',
    source: 'Commercant.count, hors filtre période',
  },
  commercants: {
    label: 'Commerçants',
    definition:
      'Nombre de boutiques enregistrées sur la plateforme. Total actuel — indépendant de la période sélectionnée.',
    source: 'Commercant.count',
  },
  commercantsActifs: {
    label: 'Boutiques actives',
    definition:
      'Boutiques marquées actives (ouvertes / visibles). Total actuel — indépendant de la période sélectionnée.',
    source: 'Commercant.count où actif=true',
  },
  pagesVues: {
    label: 'Pages vues',
    definition: 'Nombre de pages consultées sur votre boutique en ligne pendant la période.',
    source: 'page_views.count',
  },
  sessions: {
    label: 'Visites',
    definition:
      'Une visite correspond à une session de navigation sur votre boutique (une même personne peut compter plusieurs visites).',
    source: 'COUNT DISTINCT sessionId',
  },
  pagesParSession: {
    label: 'Pages vues par visite',
    definition: 'Nombre moyen de pages consultées à chaque visite sur le site.',
    source: 'pages vues / sessions',
  },
  conversion: {
    label: 'Taux de transformation en achat',
    definition:
      'Part des visites ayant abouti à une commande suivie par le site. La caisse n’est pas incluse. Les achats de test sur le site comptent s’ils ont bien été enregistrés.',
    source: 'COUNT DISTINCT sessionId PURCHASE / COUNT DISTINCT sessionId page_views',
  },
  tauxVueVersCommande: {
    label: 'Taux commandes / pages vues',
    definition:
      'Indicateur approximatif (commandes payées divisées par pages vues). Peu fiable pour décider — préférer la conversion par passage sur le site.',
    source: 'commandes payées / page_views count (UI SA)',
  },
  vuesClickorico: {
    label: 'Vues Clickorico',
    definition:
      'Vues des pages plateforme Clickorico (hors page boutique d’un commerçant). Non mesuré de façon fiable pour le moment.',
    source: 'page_views commercantId null (tracking incomplet)',
  },
  vuesCommercants: {
    label: 'Vues commerçants',
    definition: 'Pages vues sur les boutiques en ligne des commerçants.',
    source: 'page_views avec commercantId',
  },
  moyenneBoutiqueActive: {
    label: 'Moyenne / boutique active',
    definition: 'Vues commerçants divisées par le nombre de boutiques actives.',
    source: 'vuesCommercants / commercantsActifs',
  },
  giftVendu: {
    label: 'Cartes cadeaux vendues',
    definition: 'Montant face des cartes cadeaux émises pendant la période (hors remboursées/annulées).',
    source: 'GiftCard.initialValueCents, issuedAt ∈ période',
  },
  giftUtilise: {
    label: 'Montant utilisé',
    definition:
      'Montant réellement consommé sur les cartes pendant la période. Une utilisation annulée ou remboursée ne compte pas.',
    source: 'HOLD capturé via REDEEM.settlesHoldId',
  },
  giftEncours: {
    label: 'Encours disponible',
    definition: 'Solde encore disponible sur les cartes à la date de fin de période.',
    source: 'balance reconstruit ≤ endDate',
  },
  giftTaux: {
    label: 'Taux d’utilisation des cartes vendues',
    definition:
      'Part du montant des cartes vendues sur la période qui a déjà été utilisée jusqu’à la fin de période.',
    source: 'captured used cohorte / sold net',
  },
  giftExpirations: {
    label: 'Expirations à venir',
    definition:
      'Cartes encore avec solde qui expirent dans les 30 ou 7 jours à partir de la fin de période.',
    source: 'stock outstanding + expiresAt',
  },
  pageTypeBoutique: {
    label: 'Pages boutique',
    definition: 'Nombre de consultations de la page d’accueil / vitrine de votre boutique en ligne.',
    source: 'page_views pageType=MERCHANT',
  },
  pageTypeProduit: {
    label: 'Fiches produit',
    definition: 'Nombre de consultations de fiches produit sur votre boutique en ligne.',
    source: 'page_views pageType=PRODUCT',
  },
  geoVisites: {
    label: 'Origine géographique des pages vues',
    definition:
      'Répartition estimée des pages consultées selon le pays détecté. Compte des pages vues, pas des passages. Pas de ville disponible.',
    source: 'page_views.country (optionnel)',
  },
  csvComportement: {
    label: 'Export parcours site (CSV)',
    definition:
      'Fichier de la période : visiteurs, parcours d’achat, recherches et sessions récentes. Ce n’est pas l’export de toute la fiche Clients.',
    source: 'GET /analytics/commercant/:id/comportement-export',
  },
};

export function kpiHelp(key) {
  return ANALYTICS_KPI_DEFINITIONS[key]?.definition || '';
}

export function kpiLabel(key) {
  return ANALYTICS_KPI_DEFINITIONS[key]?.label || key;
}
